import { useState } from "react";
import { Input } from "@arco-design/web-react";
import {
  IconCheckCircle,
  IconCloseCircle,
  IconFile,
} from "@arco-design/web-react/icon";
import "./EditInput.less";

interface IEditInputProps {
  onPressEnter: () => void;
}

const EditInput: React.FC<IEditInputProps> = (props) => {
  const { onPressEnter } = props;
  const [fileName, setFileName] = useState("");
  return (
    <div className="edit-input-wrapper">
      <IconFile style={{ fontSize: 19 }} />
      <Input
        onPressEnter={() => {
          onPressEnter();
        }}
        value={fileName}
        onChange={(e) => {
          setFileName(e);
        }}
      />
      {fileName ? (
        <IconCheckCircle style={{ fontSize: 19, color: "#00B42A" }} />
      ) : (
        <IconCloseCircle style={{ fontSize: 19, marginLeft: 12 }} />
      )}
    </div>
  );
};

export default EditInput;
